import { render, staticRenderFns } from "./home-carousel.vue?vue&type=template&id=6b68bc68&"
import script from "./home-carousel.vue?vue&type=script&lang=js&"
export * from "./home-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports